<ng-container *ngIf="!authenticationRequired || (this.authState$ | async); else login">
  <ng-content></ng-content>
</ng-container>

<ng-template #login>
  <app-login></app-login>
</ng-template>